import { EditOrdersModal } from './setup/editOrdersModal'
import { ConfirmOrdersModal } from './setup/confirmOrdersModal'
import { RejectOrdersModal } from './setup/rejectOrdersModal'

const setup = {
  EditOrdersModal,
  ConfirmOrdersModal,
  RejectOrdersModal
}

export const modalStructures = {
  type: name => setup[name]
}



// WEBPACK FOOTER //
// ./src/skeletons/structures/index.js